import { render, staticRenderFns } from "./SearchCreate.vue?vue&type=template&id=531b836d"
import script from "./SearchCreate.vue?vue&type=script&lang=js"
export * from "./SearchCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports